var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValidationAdd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "17px",
    viewBox: "0 0 23 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Add Validation ivon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.61313593,10.2464367 C1.60295965,10.1215816 1.55481802,10.0053372 1.47379919,9.90983669 L0.393939419,8.64249855 C-0.13131314,8.02565948 -0.13131314,7.13053831 0.393939419,6.51409064 L1.47379919,5.2467525 C1.55481802,5.15125203 1.60335105,5.03500762 1.61313593,4.9101525 L1.74542756,3.25063622 C1.81000779,2.44318762 2.44289407,1.81030134 3.25034267,1.7457211 L4.90985895,1.61342948 C5.03471407,1.60364459 5.15095849,1.55550297 5.24645895,1.47409273 L6.5134057,0.394232965 C7.13024477,-0.131410988 8.02497453,-0.131410988 8.6418136,0.394232965 L9.90915174,1.47409273 C10.0042608,1.55511157 10.1208966,1.60364459 10.2457517,1.61342948 L11.905268,1.7457211 C12.7127166,1.80990994 13.3456029,2.44318762 13.4101831,3.25063622 L13.5424748,4.9101525 C13.5522597,5.03500762 13.6004013,5.15125203 13.6818115,5.2467525 L14.7616713,6.51409064 C15.2869238,7.13092971 15.2869238,8.02605087 14.7616713,8.64249855 L13.6818115,9.90983669 C13.6007927,10.0053372 13.5522597,10.1215816 13.5424748,10.2464367 L13.4101831,11.905953 C13.3456029,12.7134016 12.7127166,13.3462878 11.905268,13.4108681 L10.2457517,13.5431597 C10.1208966,13.5529446 10.0046522,13.6010862 9.90915174,13.6824965 L8.642205,14.7623562 C8.33378547,15.0249825 7.95608895,15.1564913 7.57800105,15.1564913 C7.19991314,15.1564913 6.82221663,15.0249825 6.51379709,14.7623562 L5.24645895,13.6824965 C5.15095849,13.6014776 5.03471407,13.5529446 4.90985895,13.5431597 L3.25034267,13.4108681 C2.44289407,13.3462878 1.81000779,12.7134016 1.74542756,11.905953 L1.61313593,10.2464367 Z M3.83415385,7.973 L3.89692308,8.0699 L6.34492308,10.7831 C6.40769231,10.8477 6.47046154,10.88 6.56461538,10.88 C6.65876923,10.88 6.72153846,10.8477 6.78430769,10.7831 L11.8058462,5.4213 C11.9313846,5.2921 11.9313846,5.0983 11.8058462,4.9691 L11.3664615,4.5169 C11.2409231,4.3877 11.0526154,4.3877 10.9270769,4.5169 L10.8956923,4.5169 L6.69015385,9.0066 C6.62738462,9.0712 6.53323077,9.0712 6.47046154,9.0066 L4.74430769,7.1009 L4.71292308,7.0686 C4.58738462,6.9394 4.39907692,6.9394 4.27353846,7.0686 L3.83415385,7.5208 C3.77138462,7.5854 3.74,7.6823 3.74,7.7469 C3.74,7.8115 3.77138462,7.9084 3.83415385,7.973 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile4-",
    transform: "translate(-223.000000, -1453.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Validation",
    transform: "translate(120.000000, 1197.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(20.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(66.000000, 225.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add-Validation-ivon",
    transform: "translate(17.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Validation"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/dark-grey",
    transform: "translate(0.680000, 1.020000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#646464",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/white",
    mask: "url(#mask-2)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.680000, -1.020000)",
    id: "colour/light-grey"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M21.8954049,3.22182856 L19.9536517,3.22182856 L19.9536517,1.09807034 C19.9536517,0.491715536 19.5042609,0 18.9496855,0 C18.3951102,0 17.9457193,0.491715536 17.9457193,1.09807034 L17.9457193,3.22182856 L16.0039662,3.22182856 C15.4493909,3.22182856 15,3.7135441 15,4.31989891 C15,4.92625371 15.4493909,5.41796925 16.0039662,5.41796925 L17.9457193,5.41796925 L17.9457193,7.54192966 C17.9457193,8.14828446 18.3951102,8.64 18.9496855,8.64 C19.5042609,8.64 19.9536517,8.14828446 19.9536517,7.54192966 L19.9536517,5.41817144 L21.8954049,5.41817144 C22.4499802,5.41817144 22.8993711,4.9264559 22.8993711,4.32010109 C22.8993711,3.7135441 22.4499802,3.22182856 21.8954049,3.22182856 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidationAdd);
export default __webpack_public_path__ + "static/media/validationAdd.590e676d68f733c4ceea71a8760932e3.svg";
export { ForwardRef as ReactComponent };